import React from "react";
import "./OrderInfoModal.css";
import { MdClose } from "react-icons/md"; // Import close icon

const OrderInfoModal = ({ onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content info-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close Cross Icon */}
        <button className="close-icon-btn" onClick={onClose} aria-label="Close">
          <MdClose size={28} />
        </button>

        <h2>How to Place Your Order</h2>

        <div className="info-steps">
        
          <h3>Step 1: Details</h3>
          <ul>
            <li>Select or add your delivery site (address, state, pincode)</li>
            <li>Choose the cement grade</li>
            <li>Select quantity either in bags (240 to 2000 or custom) or in MT (25 to 45 MT)</li>
            <li>Click <b className="boldinfo">"Rate Request"</b> when all fields are filled</li>
          </ul>

          <h3>Step 2: Rate</h3>
          <ul>
            <li>Click <b className="boldinfo">"Get Today's Rate"</b> to request the latest rate for your selection</li>
            <li>Wait for the supplier to approve and share the rate (usually same day)</li>
            <li>Once rate appears, you can proceed (or negotiate if needed)</li>
            <li>You can <b className="boldinfo">skip</b> this step if you already know the rate</li>
          </ul>

          <h3>Step 3: Documents</h3>
          <ul>
            <li>Upload required company documents (GST, PAN, Work Order, etc.)</li>
            <li>Select TDS or TCS and upload the respective certificate</li>
            <li>If documents were already approved for this site & brand, you can <b className="boldinfo">skip</b> </li>
            <li>New uploads will be verified by the supplier team</li>
          </ul>

          <h3>Step 4: Payment</h3>
          <ul>
            <li>View calculated amount based on rate and quantity</li>
            <li>If you have site balance, it will be adjusted automatically</li>
            <li>Upload Purchase Order (PO)</li>
            <li>Make advance payment (if required) via bank transfer</li>
            <li>Either upload payment proof or enter UTR number</li>
            <li>Review and <b className="boldinfo">confirm</b>  your order</li>
          </ul>

          <p>After submission, the supplier will review and confirm payment/dispatch soon.</p>
          <p>For support, contact your supplier directly.</p>
        </div>

        {/* Optional: Keep the bottom Close button or remove if you prefer only the cross */}
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default OrderInfoModal;